// @ts-strict-ignore
import React, {
  useContext,
  useMemo,
  useRef,
  useState,
} from 'react';
import { ThresholdContext } from './context';
import MLAAttributeContainer from 'flow/editor/components/mla/MLAAttributeContainer/MLAAttributeContainer';
import { MLAAttributeItemOrigin } from 'flow/editor/components/NodeEditorDrawer/types';
import { MLAEditorContext } from 'flow/editor/components/mla/context';
import { CaretIndexType } from 'flow/editor/components/useCaretControl/constants';
import { useCaretControl } from 'flow/editor/components/useCaretControl/useCaretControl';
import type { MLASourceData } from 'flow/editor/components/mla/types';
import { useAppDispatch, useAppSelector } from '~/store/reduxHooks';
import { selectRuleBuilderActiveSubEditor } from 'flow/store/redux/selectors';
import { resetSubEditor } from 'flow/store/redux/thunks';
import { RuleBuilderSubEditorSide } from 'flow/store/engine/types';
import { RuleBuilderContext } from '../../context';


const MLAWrapper = () => {
  const dispatch = useAppDispatch();
  const activeSubEditor = useAppSelector(selectRuleBuilderActiveSubEditor);
  const { populatedThreshold } = useContext(ThresholdContext);
  const { keyboardFocus } = useContext(RuleBuilderContext);

  const mlaEditorPanelBoxContainerRef = useRef(null);
  const [mlaContextSourceData, setMlaContextSourceData] = useState<MLASourceData>({
    type: undefined,
    data: undefined,
    attributeTokenMap: undefined,
  });

  const mlaCaretControl = useCaretControl({
    mlaData: mlaContextSourceData?.attributeTokenMap?.components,
    caretType: CaretIndexType.MLA,
    sourceId: mlaContextSourceData?.attributeTokenMap?.attribute.attribute_id,
    ruleEditorPanelBoxContainerRef: mlaEditorPanelBoxContainerRef,
    isMatrixModelFocused: false, // @todo: we need to support this when MM supports keyboard nav in the refactored rule editor
  });

  const mlaContext = useMemo(() => ({
    sourceData: mlaContextSourceData,
    setSourceData: setMlaContextSourceData,
    mlaEditorPanelBoxContainerRef,
    handleCloseMLAEditor: () => {
      dispatch(resetSubEditor());
      keyboardFocus.enable();
    },
    ...mlaCaretControl,
  }), [dispatch, keyboardFocus, mlaContextSourceData, mlaCaretControl]);

  return (
    <MLAEditorContext.Provider value={mlaContext}>
      <MLAAttributeContainer
        indentLevel={0}
        origin={
          activeSubEditor.side === RuleBuilderSubEditorSide.LHS
            ? MLAAttributeItemOrigin.THRESHOLD_LEFT
            : MLAAttributeItemOrigin.THRESHOLD_RIGHT
        }
        data={{ threshold: populatedThreshold }}
      />
    </MLAEditorContext.Provider>
  );
};

export default MLAWrapper;
